import { dispatcher, api } from '@unicus/react-ui-kit';

export const USER = 'USER';
export const USER_UPDATE_PASSWORD = 'USER_UPDATE_PASSWORD';
export const USER_SAVE_PASSWORD = 'USER_SAVE_PASSWORD';
export const USER_SAVE_PASSWORD_FINISHED = 'USER_SAVE_PASSWORD_FINISHED';
export const USER_SAVE_PASSWORD_FAILED = 'USER_SAVE_PASSWORD_FAILED';
export const USER_CURRENT_GET = 'USER_CURRENT_GET';
export const USER_CURRENT_GET_FINISHED = 'USER_CURRENT_GET_FINISHED';
export const USER_CURRENT_CANCEL = 'USER_CURRENT_CANCEL';
export const USER_CURRENT_UPDATE = 'USER_CURRENT_UPDATE';
export const USER_CURRENT_UPDATE_FINISHED = 'USER_CURRENT_UPDATE_FINISHED';

export const USER_REPORT_INITIALIZE = 'USER_REPORT_INITIALIZE';
export const USER_REPORT_CANCEL = 'USER_REPORT_CANCEL';
export const USER_REPORT_SEND = 'USER_REPORT_SEND';
export const USER_FIND = 'USER_FIND';
export const USER_REPORT_FAIL = 'USER_REPORT_FAIL';
export const USER_REPORT_SEND_FINISHED = 'USER_REPORT_SEND_FINISHED';
export const USER_CONTRIBUTOR_DELETE = 'USER_CONTRIBUTOR_DELETE';
export const USER_CONTRIBUTOR_DELETE_FINISHED =
  'USER_CONTRIBUTOR_DELETE_FINISHED';

export const USER_GET_MY_PREFERENCES = 'USER_GET_MY_PREFERENCES';
export const USER_GET_MY_PREFERENCES_FINISHED =
  'USER_GET_MY_PREFERENCES_FINISHED';

export const USER_UPDATE_MY_PREFERENCES = 'USER_UPDATE_MY_PREFERENCES';
export const USER_UPDATE_MY_PREFERENCES_FINISHED =
  'USER_UPDATE_MY_PREFERENCES_FINISHED';
export const USER_CANCEL_MY_PREFERENCES = 'USER_CANCEL_MY_PREFERENCES';

export const USER_POST_COMPANY = 'USER_POST_COMPANY';
export const USER_POST_COMPANY_FINISHED = 'USER_POST_COMPANY_FINISHED';

export const USER_PUT_COMPANY = 'USER_PUT_COMPANY';
export const USER_PUT_COMPANY_FINISHED = 'USER_PUT_COMPANY_FINISHED';

export const updatePassword = (payload) => (dispatch) => {
  dispatch(dispatcher.createAction(USER_UPDATE_PASSWORD, 'users', payload));
};

export const savePassword = (userId, payload, onSuccess, onFail) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'users',
    actionType: USER_SAVE_PASSWORD,
    effect: async () => api.put('users/password', { ...payload, id: userId }),
    onSuccess,
    onFail
  });
};

export const savePasswordFailed = () => (dispatch) => {
  dispatch(dispatcher.createAction(USER_SAVE_PASSWORD_FAILED, 'users'));
};

export const currentUserUpdate = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'users',
    actionType: USER_CURRENT_UPDATE,
    payload: data,
    effect: async () => api.put(`users/current-user`, data),
    onSuccess
  });
};

export const currentUserGet = (id) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'users',
    actionType: USER_CURRENT_GET,
    effect: async () => api.get('users', 'current-user')
  });
};

export const currentUserCancel = () => (dispatch) => {
  dispatch(dispatcher.createAction(USER_CURRENT_CANCEL, 'users'));
};

export const initializeReport = (payload) => (dispatch) => {
  dispatch(dispatcher.createAction(USER_REPORT_INITIALIZE, 'users', payload));
};

export const cancelReport = (payload) => (dispatch) => {
  dispatch(dispatcher.createAction(USER_REPORT_CANCEL, 'users', payload));
};

export const onFailReport = () => (dispatch) => {
  dispatch(dispatcher.createAction(USER_REPORT_FAIL, 'users'));
};

export const sendReport = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'users',
    actionType: USER_REPORT_SEND,
    effect: async () => api.post('users/report', data),
    onSuccess,
    onFail: () => dispatch(onFailReport())
  });
};

export const findByFederalTaxNumber = (
  federaltaxnumber,
  onSuccess,
  onFail
) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'users',
    actionType: USER_FIND,
    effect: async () =>
      api.get('users', `find/?federaltaxnumber=${federaltaxnumber}`),
    onSuccess,
    onFail
  });
};

export const removeContributor = (id, onSuccess, onFail) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'users',
    actionType: USER_CONTRIBUTOR_DELETE,
    effect: async () => api.del('users', `${id}/contributor`),
    onSuccess,
    onFail
  });
};

export const getMyPreferences = (onSuccess, onFail) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'users',
    actionType: USER_GET_MY_PREFERENCES,
    effect: async () => api.get('users', 'current-preferences'),
    onSuccess,
    onFail
  });
};

export const updateMyPreferences = (data, onSuccess, onFail) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'users',
    actionType: USER_UPDATE_MY_PREFERENCES,
    payload: data,
    effect: async () => api.put('users/current-preferences', data),
    onSuccess,
    onFail
  });
};

export const cancelMyPreferences = () => (dispatch) => {
  dispatch(dispatcher.createAction(USER_CANCEL_MY_PREFERENCES, 'users'));
};
